import { Link } from 'react-router-dom'
import Arrowsvg from '../../assets/images/Arrow'

export default function Parallex() {
    return (
        <div className="parallax test wow fadeInUp">
            <div className="parallax-text">
                <div className="col-md-9 float-left">
                    <h2 className="wow bounceInLeft">Discover Our Capabilities.</h2>
                    <p className="wow bounceInLeft">We will help you to achieve your goals and to grow your business.</p>
                </div>
                <div className="col-md-3 float-right">
                    <div className="parallax-button float-right wow bounceInRight">
                        <Link to="/contact" className="float-right">Contact Us
                        <Arrowsvg />
                            {/* <?xml version="1.0" encoding="utf-8"?>
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewbox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                  <path d="M307.2,51.2L271.4,87l143.4,143.4H0v51.2h414.7L271.4,425l35.8,35.8L512,256L307.2,51.2z"></path>
                </svg> */}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}